import { __assign } from "tslib";
// import { ContainerTreeList } from "./defaults/components/ContainerTreeList";
import { ContainerListItem } from "./defaults/components/ContainerListItem";
import { LoadingLine } from "./defaults/components/LoadingLine";
import { ErrorNode } from "./defaults/components/ErrorNode";
export var getComponents = function (options) {
    var components = {
        // listComponent: ContainerTreeList,
        listItemComponent: ContainerListItem,
        loadingLine: LoadingLine,
        errorNode: ErrorNode
    };
    if (options) {
        return __assign(__assign({}, components), options);
    }
    return components;
};
//# sourceMappingURL=getComponents.js.map